function BlankLayout({ children }) {
  return <>{children}</>;
}

export default BlankLayout;
